import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import Auth from '../../services/api/auth';
import AuthUserContext from '../Session/AuthUserContext';

const AuthenticationProtection = ({
    children,
    routeProtection,
    match,
    history,
    location,
    fullScreen,
}) => {
    const [allowed, setAllowed] = useState(false);
    const isAuthenticated = Auth.isUserAuthenticated();
    const { showSignIn } = useContext(AuthUserContext);
    const replace = !!routeProtection;
    useEffect(() => {
        if (!isAuthenticated) {
            setAllowed(false);
            showSignIn(null, { match, history, location, replace, fullScreen });
            return;
        }
        setAllowed(true);
    }, [isAuthenticated, showSignIn]);

    if (allowed) {
        return children;
    } else {
        return null;
    }
};

export default withRouter(AuthenticationProtection);
